package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.constants.StringConstants

class RemoveColonSplitterUseCase {

    operator fun invoke(text: String): String =
        text.replace(oldValue = StringConstants.COLON_SPLITTER, newValue = "")

}
